import { useSelector } from 'react-redux';
import { useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
// material
import { useTheme, styled } from '@mui/material/styles';
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { AppState } from '../../redux/rootReducerTypes';
import useEmbedded from '../../hooks/useEmbedded';

// ----------------------------------------------------------------------

export const APP_BAR_MOBILE = 64;
export const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  // backgroundColor: '#C9D1D3'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  //  backgroundColor: '#C9D1D3',

  paddingTop: APP_BAR_MOBILE + 20,
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_MOBILE + 20,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------

type DashboardLayoutProps = {
  navConfig?: {
    subheader: string;
    items: any[];
  }[];
};

export default function DashboardLayout(props: DashboardLayoutProps) {
  const title = useSelector((state: AppState) => state.dashboardState.title);
  const isEmbedded = useEmbedded();
  const theme = useTheme();
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);

  return (
    <>
      {
        isEmbedded ?
          <Outlet />
          :
          <RootStyle>
            <DashboardNavbar
              onOpenSidebar={() => setOpen(true)}
              title={title}
              showModuleSelectorButton={props.navConfig !== undefined}
              showOpenSideBarButton={props.navConfig !== undefined}
            />
            {
              props.navConfig &&
              <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} navConfig={props.navConfig} />
            }
            <MainStyle
              sx={{
                transition: theme.transitions.create('margin', {
                  duration: theme.transitions.duration.complex
                }),
                ...(collapseClick && {
                  ml: '102px'
                })
              }}
            >
              <Outlet />
            </MainStyle>
          </RootStyle>
      }
    </>
  );
}
